/**
 * Classe para formatar o field do tipo metros ou pés.
 * @author: Adalto Junior
 * DATE: 20/08/2014
 */



Monet.Format = Monet.Format || {};
Monet.Format.METERS_OR_FEET = (function () {

    function METERS_OR_FEET(value) {

        Monet.Format.DISTANCE.apply(this, arguments);

        this.value = value;

        this.toGrid = function () {
          if (typeof this.value === "number") {
            if (Monet.Session.User.unitSystem === 'NON_METRIC') {

              this.convertMetersToFeet();
              this.format();
              this.value += ' ' + Monet.I18n.getResourcesByKey('UnitSystems.Feet.abbreviation');

            } else {
              this.format();
              this.value += ' ' + Monet.I18n.getResourcesByKey('UnitSystems.Meters.abbreviation');
            }
          } else {
            this.value = '';
          }

          return this;

        };

    }

    return METERS_OR_FEET;

}());
